import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { QueryBuilderService } from './ag-grid/query-builder/query-builder.service';
import { DataRequest } from './ag-grid/query-builder/models/query-builder-request.model';
import { DeliveryTimeCategoryApiModel } from 'app/models/delivery-time-category-api.model';

@Injectable()
export class MwDeliveryTimeCategoriesApiService {
  constructor(
    private http: MwHttpService,
    private queryBuilderService: QueryBuilderService
  ) {}

  private apiEndpoint = `/transport/v1/Companies/{companyId}/DeliveryTimeCategories`;

  get(request?: DataRequest): Observable<DeliveryTimeCategoryApiModel[]> {
    let query = request
      ? this.queryBuilderService.buildOdataQuery(request, false)
      : '';
    query = query.length > 0 ? '?' + query : query;
    return this.http.authGet<DeliveryTimeCategoryApiModel[]>(
      this.apiEndpoint + query
    );
  }
}
